module.exports = __webpack_public_path__ + "static/sunshine-in-the-woods-650a98c08b4321fcff958bbe3e045fff.jpg";